import React from 'react'
import { H1, H2, H3 } from '../Semantic/Semantic'

export const RankedHeadingContext = React.createContext<{ rank: number }>({
  rank: 1,
})

export const headingsByRank: Record<number, typeof H1 | typeof H2 | typeof H3> =
  {
    1: H1,
    2: H2,
    3: H3,
    4: H3,
    5: H3,
    6: H3,
  }
